import React from 'react'
import { Form, Row, Col } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import { number, object, setLocale, string } from 'yup'
import moment from 'moment'

import {
  DatePickerRange,
  SelectParticipant,
  SelectResource
} from 'src/components/Formik'
import { stringify } from 'src/core/hooks/use-translation'
import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

function getInitialValues() {
  return {
    end_date: moment().utc().endOf('month').unix(),
    organization_id: '',
    participant: '',
    service_id: '',
    start_date: moment().utc().startOf('month').unix()
  }
}

function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={24}>
          <SelectOrganizationCurrentManager
            formikProps={formikProps}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SelectParticipant
            formikProps={formikProps}
            label="web.reports.parameter.participant.title"
            name="participant"
            placeholder="web.reports.parameter.participant.placeholder"
            required={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <SelectResource
            formikProps={formikProps}
            keyLabel="name"
            keyValue="service_id"
            label="web.receipt.form.service.title"
            name="service_id"
            placeholder="web.receipt.form.service.placeholder"
            resource="services"
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div>
            <DatePickerRange
              formikProps={formikProps}
              label="web.reports.parameter.period.title"
              name={['start_date', 'end_date']}
              placeholder={[
                'web.reports.parameter.period.placeholder-start',
                'web.reports.parameter.period.placeholder-end'
              ]}
              required
              showTime={false}
            />
          </div>
        </Col>
      </Row>
    </Form>
  )
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })
  return object().shape({
    end_date: number()
      .when('start_date', (start_date: number, schema: any) =>
        schema.max(
          moment.unix(start_date).add(31, 'days').unix(),
          stringify('web.reports.parameter.period.range-error', { value: 31 })
        )
      )
      .required()
      .typeError(),
    organization_id: string().required(),
    participant: number().notRequired(),
    service_id: number().required(),
    start_date: number().required().typeError()
  })
}

export { getInitialValues, getRenderForm, getValidationSchema }
